export function findHighlightedCardElement(
  highlightedContactId?: string,
  highlightedInvestorId?: string,
): HTMLElement | null {
  if (highlightedContactId) {
    return document.querySelector(`[data-contact-id="${highlightedContactId}"]`);
  }
  if (highlightedInvestorId) {
    return document.querySelector(`[data-investor-id="${highlightedInvestorId}"]`);
  }
  return null;
}

export function applyHighlightAnimation(element: HTMLElement): void {
  element.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'center',
  });
  element.classList.add('highlighted-card-flash');
  setTimeout(() => {
    element.classList.remove('highlighted-card-flash');
    element.classList.add('highlighted-card-persistent');
  }, 2000);
}
